// extracted by mini-css-extract-plugin
module.exports = {"filter":"_1_jKUSZe","column":"_1Qo0ctd8"};